<template>
  <transition name="modal">
    <div v-if="showHelper" id="container-floating" :class="{ '-hidden': hidden }">
      <div class="z-helper" style="position: relative">
        <transition name="fade">
          <div v-if="showModal" class="z-message">
            <button type="button" class="close" @click="onClose">
              <span aria-hidden="true">&times;</span>
            </button>
            <p style="font-weight: 600">น้องซีมีอัพเดทใหม่มาแล้ว :D</p>

            <div
              v-if="false && selectedBot.note == 'ชดเชยวันหมดอายุ'"
              style="
                border: 1px solid #3fe83f;
                border-radius: 5px;
                padding: 10px;
                margin-bottom: 15px;
                background: #e1ffca;
              "
            >
              เนื่องจากช่วงเช้าในวันที่ 3 กุมภาพันธ์ 2564 ที่ผ่านมา ZWIZ.AI ได้มีการอัพเกรดระบบ
              ส่งผลให้ต้องปิดระบบชั่วคราว ทีมงานต้องขออภัยอย่างยิ่งในความไม่สะดวกนี้นะคะ
              และเพื่อเป็นการชดเชยให้กับลูกค้า ทีมงาน ZWIZ.AI จึงทำการ<span
                class="primary--text font-weight-bold"
                >เพิ่มแพ็คเกจพรีเมี่ยมให้กับลูกค้าทุกท่านเป็นจำนวน 30 วัน</span
              >ค่ะ <br />
              <br />

              <div class="caption">ZWIZ.AI TEAM</div>
            </div>

            <span v-if="selectedBot.theme == 'ecommercebasic'">
              <p>
                เชื่อมต่อขนส่งแบบใหม่ แจ้งเลขพัสดุถึงลูกค้าไวกว่าเดิม
                <a @click="goNavLink('/template?tab=ShippingMethod')">คลิกดูเพิ่มเติม!</a>
              </p>
            </span>

            <div>
              <template v-if="selectedBot.status">
                <a :href="'https://m.me/' + selectedBot.pageid + '?ref=menu'" target="blank">{{
                  $t('test this bot')
                }}</a>
                |
              </template>
              <template v-else>
                <a href="javascript:void(0)" @click="toggleBotStatus">{{ $t('start your bot') }}</a>
                |
              </template>
              <a
                href="https://blog.zwiz.ai/getstarted-zwizai/"
                target="_blank"
                rel="noopener noreferrer"
                >{{ $t('help') }}</a
              >
              |
              <a
                href="https://m.me/361231620965547?ref=Complaints"
                target="_blank"
                rel="noopener noreferrer"
                >Feedback</a
              >
            </div>
          </div>
        </transition>
        <div class="floating-btn" @click="hidden ? show() : clicktooltip()">
          <div style="position: relative; width: 100%; height: 100%">
            <div
              :style="{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                margin: '-0.25rem -0.5rem 0'
              }"
            >
              <v-btn v-if="!hidden" icon small color="white" class="ma-0" @click.stop="hide">
                <v-icon small>close</v-icon>
              </v-btn>
              <div v-if="hasupdate" class="numnew">!</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import carousel from 'vue-owl-carousel'
import { mapGetters } from 'vuex'
import api from '@/api'

export default {
  components: { carousel },
  data: function () {
    return {
      newfeature: 'cartsummary',
      hasupdate: false,
      showFinish: false,
      showModal: false,
      hiddenWelcomeFloatingButtonUsers: []
    }
  },
  computed: {
    ...mapGetters({
      showModalWelcome: 'showModalWelcome',
      selectedBot: 'selectedBot',
      botlist: 'botlist'
    }),
    showHelper() {
      return this.$localStorage.get('app_type') !== 'warroom'
    },
    hidden() {
      return this.hiddenWelcomeFloatingButtonUsers.includes(this.$store.state.userid)
    }
  },
  watch: {
    showModal: function () {}
  },
  mounted: function () {
    var vm = this
    vm.showModal = vm.showModalWelcome
    // if (this.selectedBot.note == 'ชดเชยวันหมดอายุ') {
    //   this.newfeature = 'ชดเชยวันหมดอายุ030221'
    // }
    document.addEventListener('keydown', (e) => {
      if (e.keyCode == 27) {
        vm.showModal = false
      }
    })
    this.checkupdate()
    this.loadWelcomeFloatingButtonVisible()
  },
  methods: {
    checkupdate() {
      var value = this.$localStorage.get('newupdate')
      if (value) {
        var feature = JSON.parse(value)
        if (feature.update == this.newfeature) {
          this.hasupdate = !feature.readed
        } else {
          this.hasupdate = true
        }
      } else {
        this.hasupdate = true
      }
    },
    clicktooltip() {
      this.showModal = true
      var data = { update: this.newfeature, readed: true }
      this.$localStorage.set('newupdate', JSON.stringify(data))
      this.hasupdate = false
    },
    goNavLink(link) {
      this.$router.push('/' + this.$store.getters.currentLang + link)
    },
    changed: function (event) {
      this.showFinish = event.item.index == event.item.count - 1
    },
    updated: function () {},
    onClose: function () {
      this.showModal = false
      this.$store.dispatch('clearModalWelcome')
    },
    toggleBotStatus: function () {
      let vm = this
      let bot = Object.assign({}, vm.selectedBot)
      bot.status = !bot.status

      let in_status_label = bot.status ? 'stop' : 'start'
      vm.$store.dispatch('loading')
      api.toggleBotStatus(bot, function (error, response) {
        if (error) {
          console.error(error)
          vm.$store.dispatch('loading')
          return
        }

        let newbotlist = vm.botlist
        $.each(newbotlist, function (index, oldbot) {
          if (bot.pageid == oldbot.pageid) {
            newbotlist[index].status = bot.status
            return false
          }
        })
        // console.log(bot)
        vm.botStatus = bot.status
        vm.$store.dispatch('selectBot', bot)
        vm.$store.dispatch('updateBotlist', newbotlist)
        vm.$store.dispatch('loading')
      })
    },
    hide() {
      try {
        this.showModal = false
        this.hiddenWelcomeFloatingButtonUsers.push(this.$store.state.userid)
        this.$localStorage.set(
          'hiddenWelcomeFloatingButtonUsers',
          JSON.stringify(this.hiddenWelcomeFloatingButtonUsers)
        )
      } catch (error) {
        //
      }
    },
    show() {
      this.hiddenWelcomeFloatingButtonUsers = this.hiddenWelcomeFloatingButtonUsers.filter(
        (id) => id !== this.$store.state.userid
      )
      this.$localStorage.set(
        'hiddenWelcomeFloatingButtonUsers',
        JSON.stringify(this.hiddenWelcomeFloatingButtonUsers)
      )
    },
    loadWelcomeFloatingButtonVisible() {
      try {
        const value = this.$localStorage.get('hiddenWelcomeFloatingButtonUsers', '[]')
        this.hiddenWelcomeFloatingButtonUsers = JSON.parse(value)
      } catch (error) {
        //
      }
    }
  }
}
</script>

<style scoped>
.numnew {
  width: 22px;
  height: 22px;
  background-color: red;
  border: 1.2px solid white;
  color: white;
  border-radius: 99px;
  font-weight: 800;
  margin-left: auto;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/elements/ModalWelcome.vue